var __decorate=this&&this.__decorate||function(t,e,r,o){var a,n=arguments.length,i=n<3?e:null===o?o=Object.getOwnPropertyDescriptor(e,r):o;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)i=Reflect.decorate(t,e,r,o);else for(var l=t.length-1;l>=0;l--)(a=t[l])&&(i=(n<3?a(i):n>3?a(e,r,i):a(e,r))||i);return n>3&&i&&Object.defineProperty(e,r,i),i};import{ConfirmDialog as t}from"@vaadin/confirm-dialog";import{css as e,render as r,html as o}from"lit";import{customElement as a}from"lit/decorators.js";import{when as n}from"lit/directives/when.js";import{Util as i}from"@openremote/core";export function showConfirmDialog(t,e){let o=document.createElement("div");o.id=`dialog-${i.generateUniqueUUID()}`,r(e,o);let a=o.querySelector("or-vaadin-confirm-dialog");a?(a.opened=!0,a.addEventListener("closed",()=>o.remove()),a.querySelector("[slot='cancel-button']")&&(a.cancelButtonVisible=!0),a.querySelector("[slot='reject-button']")&&(a.rejectButtonVisible=!0),t.appendChild(o)):o.remove()}export function getConfirmDialogContent(t,e,r,a,i,l){return o`
    ${"string"==typeof e?o`<or-translate slot="header" value=${e}></or-translate>`:o`<div slot="header">${e}</div>`}
    ${"string"==typeof r?o`<or-translate value=${r}></or-translate>`:r}
    ${n(a,()=>o`
        <or-vaadin-button theme=${t&&t.includes(" ")?t:t+" primary"} slot="confirm-button">
          <or-translate value=${a}></or-translate>
        </or-vaadin-button>
      `)}
    ${n(i,()=>o`
        <or-vaadin-button theme=${t?`tertiary ${t}`:"tertiary"} slot="cancel-button">
          <or-translate value=${i}></or-translate>
        </or-vaadin-button>
      `)}
    ${n(l,()=>o`
        <or-vaadin-button theme=${t?`tertiary ${t}`:"tertiary"} slot="reject-button">
          <or-translate value=${l}></or-translate>
        </or-vaadin-button>
      `)}
  `}export function showErrorDialog(t,e,r="errorOccurred"){return showConfirmDialog(t,o`
      <or-vaadin-confirm-dialog>
        ${getConfirmDialogContent("error tertiary",r,e,"close")}
      </or-vaadin-confirm-dialog>
    `)}let OrVaadinConfirmDialog=class extends t{static get styles(){return[t.styles,e`
        ::part(header),
        ::part(content) {
          background-color: var(--lumo-contrast-5pct);
          margin-inline-start: 0;
        }
        ::part(header),
        ::part(footer) {
          padding: var(--lumo-space-l);
        }
        ::part(content) {
          padding: 0 var(--lumo-space-l);
        }
      `]}open(){this.setAttribute("opened","true")}close(){this.toggleAttribute("opened",!1)}};OrVaadinConfirmDialog=__decorate([a("or-vaadin-confirm-dialog")],OrVaadinConfirmDialog);export{OrVaadinConfirmDialog};